"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _RenderInBody = _interopRequireDefault(require("../RenderInBody"));
var _domElementFocus = _interopRequireDefault(require("../../utils/dom-element-focus"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  renderInBody: true,
  theme: {},
  role: 'dialog',
  ariaLabel: null,
  ariaDescribedBy: null,
  ariaLabelledBy: null,
  onClickOverlay: function onClickOverlay() {}
};

/**
 * Describe the purpose of Modal here
 */
var ModalBase = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ModalBase, _React$Component);
  function ModalBase(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ModalBase);
    _this = _callSuper(this, ModalBase, [props]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleKeyDown", function (e) {
      var _this$props = _this.props,
        onEnter = _this$props.onEnter,
        onEsc = _this$props.onEsc;
      switch (e.which) {
        case 13:
          // enter
          if (typeof onEnter === 'function') {
            e.preventDefault(); // Prevent re-rendering of the Modal component
            onEnter();
          }
          break;
        case 27:
          // esc
          if (typeof onEsc === 'function') {
            onEsc();
          }
          break;
        default:
          break;
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleModalMouseDown", function (e) {
      e.stopPropagation();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOverlayMouseDown", function () {
      var onClickOverlay = _this.props.onClickOverlay;
      onClickOverlay();
    });
    _this.container = null;
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(ModalBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.container) {
        // 1) Store the active element for later.
        _domElementFocus["default"].storeActiveElement();

        // 2) Set up focus (add event listeners, find last tabble element)
        _domElementFocus["default"].setupScopedFocus({
          ancestorElement: this.container
        });

        // 3) Check for a current active element is inside the modal.
        if (!_domElementFocus["default"].focusExists()) {
          // If nothing is active, focus the first ancestor.
          _domElementFocus["default"].focusAncestor();
        }
      }

      // When renderInBody is true, we should let the RenderInBody singleton handle the keydown events.
      // When renderInBody is false, we need to bind it to the modal ourselves
      if (!this.props.renderInBody) {
        document.body.addEventListener('keydown', this.handleKeyDown);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var shouldLetModalHandleOnKeyDown = !this.props.renderInBody;
      if (shouldLetModalHandleOnKeyDown) {
        document.body.removeEventListener('keydown', this.handleKeyDown);
      }
      _domElementFocus["default"].teardownScopedFocus();
      _domElementFocus["default"].returnFocusToStoredElement();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        className = _this$props2.className,
        testId = _this$props2.testId,
        innerRef = _this$props2.innerRef,
        children = _this$props2.children,
        theme = _this$props2.theme,
        renderInBody = _this$props2.renderInBody,
        role = _this$props2.role,
        ariaLabel = _this$props2.ariaLabel,
        ariaDescribedBy = _this$props2.ariaDescribedBy,
        ariaLabelledBy = _this$props2.ariaLabelledBy;
      var classes = (0, _classnames["default"])(className, theme.modal);
      var applyContainerRef = function applyContainerRef(ref) {
        return _this2.container = ref;
      };
      var ref = innerRef || applyContainerRef;
      var modal = /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.overlay,
        onMouseDown: this.handleOverlayMouseDown,
        "data-test-id": testId && "modal-overlay-".concat(testId)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        onMouseDown: this.handleModalMouseDown,
        "data-test-id": testId,
        "data-anypoint-component": "Modal",
        ref: ref,
        role: role
        // eslint-disable-next-line jsx-a11y/aria-props
        ,
        "aria-modal": true,
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        "aria-labelledby": ariaLabelledBy
      }, children));
      if (!renderInBody) {
        return modal;
      }
      return /*#__PURE__*/_react["default"].createElement(_RenderInBody["default"], {
        onKeyDown: this.handleKeyDown,
        orderedKeyDownHandler: true
      }, modal);
    }
  }]);
  return ModalBase;
}(_react["default"].Component);
(0, _defineProperty2["default"])(ModalBase, "defaultProps", defaultProps);
//# sourceMappingURL=ModalBase.js.map